import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Search, Instagram } from "lucide-react";
import { Input } from "../components/ui/input";
import { Badge } from "../components/ui/badge";

const Influencers = () => {
  const [influencers, setInfluencers] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/influencers${search ? `?q=${encodeURIComponent(search)}` : ""}`).then(r => setInfluencers(r.data));
    }, 200);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12" data-testid="influencers-page">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground">Verified Voices</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mt-2">Influencer Kuliner</h1>
        <p className="text-muted-foreground mt-2">Discover review otentik dari food creator Gading Serpong</p>
      </div>

      <div className="relative max-w-xl mb-10">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
        <Input
          data-testid="influencer-search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Cari influencer..."
          className="pl-12 h-12 rounded-full bg-card"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="influencers-grid">
        {influencers.map(i => (
          <Link key={i.user_id} to={`/influencers/${i.user_id}`} className="warm-card overflow-hidden group" data-testid={`influencer-${i.user_id}`}>
            <div className="aspect-[4/5] overflow-hidden bg-muted relative">
              <img src={i.picture} alt={i.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <h3 className="font-heading text-xl font-black leading-tight">{i.name}</h3>
                <p className="text-xs text-white/80 flex items-center gap-1 mt-1">
                  <Instagram className="w-3 h-3" /> {i.instagram_handle}
                </p>
              </div>
            </div>
            <div className="p-4">
              <p className="text-sm text-muted-foreground line-clamp-2">{i.bio}</p>
              <div className="flex items-center gap-2 mt-3">
                <Badge variant="secondary" className="text-xs">{i.review_count} reviews</Badge>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Influencers;
